var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1940_25411)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 14,
    fill: "#E1F3FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1940_25411)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1940_25411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 17.8437C8 14.53 10.6863 11.8438 14 11.8438H51C54.3137 11.8438 57 14.53 57 17.8438V76.8438H8V17.8437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15.8438,
    width: 17,
    height: 6,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9999,
    y: 17.8438,
    width: 11,
    height: 2,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 25.8438,
    width: 41,
    height: 10,
    fill: "#F73B58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 61.8438,
    width: 41,
    height: 5,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 37.8438,
    width: 41,
    height: 4,
    rx: 2,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 37.8438,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#46AE31"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 51.8438,
    r: 6,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9708 51.4172H18.9408V49.0172C18.9408 48.4572 18.6375 48.3438 18.2675 48.7638L18.0008 49.0672L15.7441 51.6338C15.4341 51.9838 15.5641 52.2705 16.0308 52.2705H17.0608V54.6705C17.0608 55.2305 17.3641 55.3438 17.7341 54.9238L18.0008 54.6205L20.2575 52.0538C20.5675 51.7038 20.4375 51.4172 19.9708 51.4172Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 51.8438,
    r: 6,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9708 51.4172H33.9408V49.0172C33.9408 48.4572 33.6375 48.3438 33.2675 48.7638L33.0008 49.0672L30.7442 51.6338C30.4342 51.9838 30.5642 52.2705 31.0308 52.2705H32.0608V54.6705C32.0608 55.2305 32.3642 55.3438 32.7342 54.9238L33.0008 54.6205L35.2575 52.0538C35.5675 51.7038 35.4375 51.4172 34.9708 51.4172Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 51.8438,
    r: 6,
    fill: "#E1F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9708 51.4172H48.9408V49.0172C48.9408 48.4572 48.6374 48.3438 48.2674 48.7638L48.0008 49.0672L45.7441 51.6338C45.4341 51.9838 45.5641 52.2705 46.0308 52.2705H47.0608V54.6705C47.0608 55.2305 47.3641 55.3438 47.7341 54.9238L48.0008 54.6205L50.2574 52.0538C50.5674 51.7038 50.4374 51.4172 49.9708 51.4172Z",
    fill: "#0EA3FD"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 64.4,
    height: 64.4,
    rx: 13.7,
    stroke: "#B3E2FE",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1940_25411",
    x: -2,
    y: 5.84375,
    width: 69,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1940_25411"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1940_25411",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1940_25411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1940_25411"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 17.8437C8 14.53 10.6863 11.8438 14 11.8438H51C54.3137 11.8438 57 14.53 57 17.8438V76.8438H8V17.8437Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurge);
export default __webpack_public_path__ + "static/media/surge.2b5cfd1086b550a0e87de9f12e9fd566.svg";
export { ForwardRef as ReactComponent };